module.exports = __webpack_public_path__ + "assets/img/crk-select.30bca5df.png";